/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TipoMangimeCreateDTO
 */
export interface TipoMangimeCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof TipoMangimeCreateDTO
     */
    descrizione: string;
}

/**
 * Check if a given object implements the TipoMangimeCreateDTO interface.
 */
export function instanceOfTipoMangimeCreateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "descrizione" in value;

    return isInstance;
}

export function TipoMangimeCreateDTOFromJSON(json: any): TipoMangimeCreateDTO {
    return TipoMangimeCreateDTOFromJSONTyped(json, false);
}

export function TipoMangimeCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TipoMangimeCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'],
    };
}

export function TipoMangimeCreateDTOToJSON(value?: TipoMangimeCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'descrizione': value.descrizione,
    };
}

